import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import AuthenticationView from '@/views/AuthenticationView.vue'
import AuthenticationViewTest from '@/views/AuthenticationViewTest.vue'
import HomeView from '@/views/HomeView.vue'
import ResetPass from '@/views/ResetPass.vue';
import BeruView from '@/views/BeruView.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/authentication',
    name: 'authentication',
    component: AuthenticationView
  },
  {
    path: '/authentication-test',
    name: 'authentication-test',
    component: AuthenticationViewTest
  },
  {
    path: '/beru',
    name: 'beru',
    component: BeruView
  },
  {
    path: '/reset-pass',
    name: 'authentication-restore',
    component: ResetPass
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
